import React from "react";
import { Popover, Typography } from "@mui/material";

const CustomPopover = ({ open, anchorEl, onClose, anchorOrigin, transformOrigin, options }) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      sx={{
        ".MuiPaper-root": {
          borderRadius: "16px",
        },
      }}
    >
      <div style={{ width:"200px",padding:"10px"}}>
        {options.map((option, index) => (
          <div key={index} onClick={option.onClick}>
            <Typography className="cursor-pointer" >
              {option.label}
            </Typography>
            <span>{index !== options.length - 1 && <hr/>}</span>
          </div>
        ))}
      </div>
    </Popover>
  );
};

export default CustomPopover;
